import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKey, QueryKeyParam } from '../../query/types';

const causeBackerFamiliesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'families'] as const;
  return createQueryKey({
    all: [...key] as const,
    id: <U extends QueryKeyParam>(id: U) =>
      createQueryKey({
        all: [...key, id] as const,
      }),
  });
};

export { causeBackerFamiliesKeys };
